export enum SelectTheme {
  Builder = `builder`,
  BuilderLight = `builder-light`,
  MenuFilter = `menu-filter`,
  Primary = `primary`,
  Secondary = `secondary`,
  Tertiary = `tertiary`,
  Select = `select`,
  QbSubitem = `qb-subitem`,
  QueryBuilder = `query-builder`,
  MenuFooter = `menu-footer`,
}
